export default __webpack_public_path__ + "static/media/button_linkedin.7d25a4fa.svg";